<script lang="ts" setup>
import constants from '~/constants'
import helpers from '~/helpers'

withDefaults(
  defineProps<{
    experience?: number | null
    isHelpingAdults?: boolean | undefined
    isHelpingChildren?: boolean | undefined
    isHighestCategory?: boolean | undefined
  }>(),
  {
    experience: null,
    isHelpingAdults: false,
    isHelpingChildren: false,
    isHighestCategory: false
  }
)
</script>

<template>
  <div class="-m-1">
    <template v-if="experience">
      <SpecialistLabel
        v-if="experience >= 7"
        text="Высшая категория"
      />

      <SpecialistLabel
        icon="outlined/success"
        :text="
          `
            ${experience}&nbsp
            ${helpers.getDeclension(experience, constants.wordForms.year)}&nbsp;опыта
          `
        "
      />
    </template>

    <SpecialistLabel v-if="isHelpingChildren" text="Работаю с детьми" />

    <SpecialistLabel v-if="isHelpingAdults" text="Работаю со взрослыми" />
  </div>
</template>
